import { render, staticRenderFns } from "./goodsStoreBatchAgent.vue?vue&type=template&id=6407ab84&"
import script from "./goodsStoreBatchAgent.vue?vue&type=script&lang=js&"
export * from "./goodsStoreBatchAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports